import type { QueryKey, UseQueryOptions } from 'react-query';
import type { Provider } from './types';
import { getProviders } from './api';
import { providersKey } from './keys';

export function providersQuery<T = Provider[]>(options?: UseQueryOptions<Provider[], unknown, T, QueryKey>) {
  return {
    queryKey: providersKey(),
    queryFn: () => getProviders(),
    ...options,
  } as const;
}
